import FileSaver from "file-saver";

export class XlsxColumn {
  constructor(header, key, width) {
    this.header = header;
    this.key = key;
    this.width = width;
  }
}

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return "";

  const stringValue = String(value);

  if (/[",\r\n]/.test(stringValue)) {
    return `"${stringValue.replaceAll('"', '""')}"`;
  }

  return stringValue;
};

export const exportExcelWb = (fileName, columns, rows) => {
  let csvContent = columns.map((col) => escapeCsvValue(col.header)).join(",");
  csvContent += "\n";

  rows.forEach((row) => {
    const rowContent = columns
      .map((col) => escapeCsvValue(row[col.key]))
      .join(",");
    csvContent += rowContent + "\n";
  });

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  FileSaver.saveAs(blob, `${fileName}.csv`);
};
